import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Cookies from 'universal-cookie';
import Footer from './Footer';
import Header from './Header';

const cookies = new Cookies();
function Rootroute() {
    const navigate = useNavigate();


    useEffect(() => {
        const cookie = cookies.get('token');
        if (cookie) navigate("../home", { replace: true });
    }, [])


    return (
        <div>
            <Header />
            <div className="rootbody contain">
                <div className="rootleft">
                    <h1>Fast.Secure.</h1>
                    <h1>Chat and Call</h1>
                    <p>With ChatApp you will get Fast and Free messaging and calling services.</p>
                    <small>Data connection is required. Contact your provider for details.</small>
                    <p className='rootleftp'>Use it on Apple <i class="fa-brands fa-apple"></i></p>
                    <p className='rootleftp'>Use it on Windows <i class="fa-brands fa-windows"></i></p>
                    <p className='rootleftp'>Use it on Mac <i class="fa-sharp fa-solid fa-laptop"></i></p>

                </div>
                <div  className="rootright">
                    <img className='unselectable'  dragable="false"  src="/images/mobileChatImg.png" alt="mobileImg" />
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Rootroute